export const CategoryFilterNames = {
	ALL: 'all',
	BARS: 'Bar',
	CAFES: 'Café',
	RESTAURANTS: 'Restaurant',
	CLUBS: 'Club',
	SHOPS: 'Shoppen',
	AUSFLUEGE: 'Ausflug',
	SPORT: 'Sport',
	KULTUR: 'Kultur'
};


// WEBPACK FOOTER //
// ./src/config-data/category-filters.js